import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../../base-types";
import { EntityResource } from "../entity-resource";
import { IEntityResourceContainer } from "../resource-containers/entity-resource-container";
import { GroupCategory } from "./group-category";
import { GroupConfig } from "./group-config";
import { GroupItem } from "./group-item";

@JsonObject()
export class GroupedViewResponseResource implements IEntityResourceContainer {
    @JsonProperty("available_groups")
    @JsonElementType(GroupCategory)
    availableGroups: Array<GroupCategory> = [];

    @JsonProperty("row_definition_id")
    rowDefinitionId: Nullable<number> = null;

    @JsonProperty("rows")
    @JsonElementType(GroupConfig)
    rows: Array<GroupConfig> = [];

    @JsonProperty("column_definition_id")
    columnDefinitionId: Nullable<number> = null;

    @JsonProperty("columns")
    @JsonElementType(GroupConfig)
    columns: Array<GroupConfig> = [];

    @JsonProperty("data")
    @JsonElementType(GroupItem)
    data: Array<GroupItem> = [];

    @JsonProperty("total_rows")
    totalRows: number;

    getEntityResources(): Array<EntityResource> {
        const finalItems: Array<EntityResource> = [];
        this.data.forEach(element => {
            element.items.forEach(item => finalItems.push(item));
        });
        return finalItems;
    }
}
